import React from 'react';
import { Helmet } from 'react-helmet-async';

const baseUrl = 'https://astemsoftware.com';
const defaultImage = `${baseUrl}/og-image.png`;

export default function Seo({ title, description, image = defaultImage, path = '/', author, publisher, type = 'website', noindex = false }) {
  const fullTitle = title || 'ASTEM Software Lab';
  const fullDescription = description || 'Innovative software solutions from ASTEM Software Lab.';
  const url = `${baseUrl}${path || ''}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? 'noindex,nofollow' : 'index,follow,max-image-preview:large'} />
      <meta name="googlebot" content={noindex ? 'noindex,nofollow' : 'index,follow,max-image-preview:large'} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:site_name" content="ASTEM Software Lab" />
      <meta property="og:locale" content="en_GH" />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={fullTitle} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image:alt" content={fullTitle} />

      {author && <meta name="author" content={author} />}
      {publisher && <meta name="publisher" content={publisher} />}
      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'ASTEM Software Lab',
        url: baseUrl,
        logo: `${baseUrl}/logo512.png`,
        description: fullDescription,
        sameAs: [],
      })}</script>
    </Helmet>
  );
}
